var SupportDealSummaryView, SupportV2DealSummaryView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportDealSummaryView = require('./deal_summary_view');

SupportV2DealSummaryView = (function(superClass) {
  extend(SupportV2DealSummaryView, superClass);

  function SupportV2DealSummaryView() {
    return SupportV2DealSummaryView.__super__.constructor.apply(this, arguments);
  }

  SupportV2DealSummaryView.prototype.toDealHash = function() {
    var dealHash;
    dealHash = SupportDealSummaryView.prototype.toDealHash.call(this);
    dealHash.purchasedAt = this.orderPresenter.getpurchasedAt();
    dealHash.qty = this.orderPresenter.getOrderQuantity();
    dealHash.isV2 = true;
    return dealHash;
  };

  return SupportV2DealSummaryView;

})(SupportDealSummaryView);

module.exports = SupportV2DealSummaryView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3Mvb3JkZXJfcmVsYXRlZC92Ml9kZWFsX3N1bW1hcnlfdmlldy5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9ybXVydWdhbi9uYXBpc3RyYW5vL2J1aWxkLzE1MDE3ODIwMTYzMDYtNTk0MzUvcHJvZHVjdGlvbi0yMDE3LjA4LjAzXzE3LjM2L3N1cHBvcnRfYXBwL21vZHVsZXMvc3VwcG9ydC9mcm9udGVuZC92aWV3cy9vcmRlcl9yZWxhdGVkL3YyX2RlYWxfc3VtbWFyeV92aWV3LmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBLGdEQUFBO0VBQUE7OztBQUFBLHNCQUFBLEdBQXlCLE9BQUEsQ0FBUSxxQkFBUjs7QUFFbkI7Ozs7Ozs7cUNBRUosVUFBQSxHQUFZLFNBQUE7QUFDVixRQUFBO0lBQUEsUUFBQSxHQUFXLHNCQUFzQixDQUFBLFNBQUUsQ0FBQSxVQUFVLENBQUMsSUFBbkMsQ0FBd0MsSUFBeEM7SUFDWCxRQUFRLENBQUMsV0FBVCxHQUF1QixJQUFDLENBQUEsY0FBYyxDQUFDLGNBQWhCLENBQUE7SUFDdkIsUUFBUSxDQUFDLEdBQVQsR0FBZSxJQUFDLENBQUEsY0FBYyxDQUFDLGdCQUFoQixDQUFBO0lBQ2YsUUFBUSxDQUFDLElBQVQsR0FBZ0I7V0FDaEI7RUFMVTs7OztHQUZ5Qjs7QUFTdkMsTUFBTSxDQUFDLE9BQVAsR0FBaUIifQ==
